import { useMemo } from 'react';
import { useFlag } from '@/common/hooks/feature-flags/useFlag';
import { useItemTypeLevelsQuery } from '@/common/queries/useItemTypeLevelsQuery';
import { useItemTypesQuery } from '@/common/queries/useItemTypesQuery';

const RESTRICTED_LEVELS = new Set([1, 2]);

export const useIsIntegrationAllowedForItemType = (itemTypeId: number | undefined): boolean => {
  const restrictLevels = useFlag('workIntegrationRestrictLevels');
  const { data: itemTypes } = useItemTypesQuery();
  const { data: itemTypeLevels } = useItemTypeLevelsQuery();

  return useMemo(() => {
    if (!restrictLevels) return true;
    if (itemTypeId === undefined) return true;
    const itemType = itemTypes?.find((type) => type.id === itemTypeId);
    if (!itemType) return true;
    const level = itemTypeLevels?.find((l) => l.id === itemType.itemLevelId)?.level;
    if (level === undefined) return true;
    return !RESTRICTED_LEVELS.has(level);
  }, [restrictLevels, itemTypeId, itemTypes, itemTypeLevels]);
};

export const useIsIntegrationAllowedForItemLevel = (itemLevelId: number | undefined): boolean => {
  const restrictLevels = useFlag('workIntegrationRestrictLevels');
  const { data: itemTypeLevels } = useItemTypeLevelsQuery();

  return useMemo(() => {
    if (!restrictLevels) return true;
    if (itemLevelId === undefined) return true;
    const level = itemTypeLevels?.find((l) => l.id === itemLevelId)?.level;
    if (level === undefined) return true;
    return !RESTRICTED_LEVELS.has(level);
  }, [restrictLevels, itemLevelId, itemTypeLevels]);
};
